













import { defineComponent, computed } from '@nuxtjs/composition-api';
import useBlogs from '@/modules/InformationPages/Blog/hooks/useBlogs';
import SmallCard from '@/modules/InformationPages/Blog/components/SmallCard.vue';

export default defineComponent({
  name: 'ReferredBlogs',
  components: {
    SmallCard,
  },
  setup() {
    const { fetchBlogs } = useBlogs();

    const { referralBlogs } = fetchBlogs(0, 4, true);

    const recommendedBlogs = computed(() => referralBlogs.value?.slice(0, 3));

    return {
      recommendedBlogs,
    };
  },
});
